import * as Sentry from "@sentry/nuxt"

if (import.meta.env.MODE != "development" && !import.meta.dev) {
  Sentry.init({
    dsn: useRuntimeConfig().public.sentry.dsn,

    ignoreErrors: [
      "Failed to fetch", // This error can have multiple causes, but a big one is navigating away in the browser before an API call finishes. To reproduce it, throttle your network speed in browser dev tools. Then click `Courses` and reload the page before the api call finishes.
      "Can't find variable: logMutedMessage", // Error in edge browser on iOS. See https://github.com/getsentry/sentry-javascript/issues/8444
      "sentry-ignore",
    ],

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    // If you don't want to use Session Replay, just remove the line below:
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,
  })
}
